export const kanbanColumnDefs = [
  { field: 'not_fiscal', headerName: 'NF', width: 110 },
  { field: 'num_pedido_cliente', headerName: 'Pedido do Cliente', width: 180 },
  { field: 'cliente', headerName: 'Cliente', flex: 1 },
  { field: 'cod_produto', headerName: 'Codigo Produto', width: 180 },
  { field: 'descricao', headerName: 'Descricao', flex: 1.5 },
  { field: 'quantidade', headerName: 'Quantidade', width: 120 },
  { field: 'sku', headerName: 'SKU', width: 160 },
  { field: 'local_entrega', headerName: 'Local Entrega', width: 150 },
  {
    field: 'data_kanban',
    headerName: 'Data Kanban',
    sortable: true,
    filter: 'agDateColumnFilter',
    resizable: true,
    filterParams: {
      includeTime: false,
      comparator(filterLocalDateAtMidnight, cellValue) {
        if (!cellValue) {
          return -1;
        }

        const datePart = cellValue.split('T')[0].split(' ')[0];
        const [year, month, day] = datePart.split('-').map(Number);

        if (!year || !month || !day) {
          return -1;
        }

        const cellDate = new Date(year, month - 1, day);
        cellDate.setHours(0, 0, 0, 0);

        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }

        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }

        return 0;
      },
    },
  },
  { field: 'hora_kanban', headerName: 'Hora Kanban', width: 110 },
  { field: 'caminhao', headerName: 'Caminhao', width: 140 },
  { field: 'op', headerName: 'OP', width: 120 },
  {
    field: 'status',
    headerName: 'Status',
    width: 140,
    valueGetter(params) {
      if (params.data?.caminhao) {
        return 'Liberado';
      }

      return params.data?.status ?? '';
    },
    cellStyle(params) {
      const hasTruck = !!params.data?.caminhao;
      const isLiberado = hasTruck || String(params.value ?? '').toLowerCase() === 'liberado';

      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: isLiberado ? '#e0f2fe' : '#fff8e1',
        color: isLiberado ? '#0369a1' : '#f57f17',
        fontWeight: '700',
        borderRadius: '20px',
        margin: '6px 12px',
        height: 'calc(100% - 12px)',
        textTransform: 'uppercase',
        fontSize: '10px',
        letterSpacing: '0.5px',
        border: isLiberado ? '1px solid #bae6fd' : '1px solid #fde093',
      };
    },
  },
];

export const kanbanDefaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  headerClass: 'ag-center-header',
  cellStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
};

export const kanbanRowClassRules = {
  'row-liberado': (params) => !!params.data?.caminhao,
  'row-bipado': (params) => !params.data?.caminhao && params.data?.status && params.data.status.toLowerCase() === 'bipado',
};
